import { render } from "./modal_majpunormalise.vue?vue&type=template&id=733ac8ad&scoped=true"
import script from "./modal_majpunormalise.vue?vue&type=script&lang=js"
export * from "./modal_majpunormalise.vue?vue&type=script&lang=js"

import "./modal_majpunormalise.vue?vue&type=style&index=0&id=733ac8ad&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733ac8ad"]])

export default __exports__